<template>
  <div>
    <vue-justified-layout
      :items="galleryItems"
      v-slot="{ item }"
      :options="galleryOptions"
    >
      <div class="gallery-item-template" @click="showInFeed(item)">
        <img v-lazy="item.url" data-aos="fade-up" data-aos-once="true" />
        <div v-if="item.format === 'gallery'" class="gallery-icon">
          <i class="far fa-clone fa-flip-horizontal"></i>
        </div>
        <div v-if="item.format === 'video'" class="gallery-icon">
          <i class="fas fa-play"></i>
        </div>
      </div>
    </vue-justified-layout>
    <div v-if="false">
      <lottie :options="lottieOptions" :height="300" />
    </div>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import debounce from "../mixins/debounce";
import * as animationData from "../assets/loading_lottie.json";
import AOS from "aos";
import "aos/dist/aos.css";
import Constants from "../assets/constants";

export default {
  name: "ImageGallery",
  components: {
    lottie: Lottie
  },
  mixins: [debounce],
  data() {
    return {
      lottieOptions: { animationData: animationData.default },
      windowWidth: window.innerWidth,
      galleryOptions: {
        targetRowHeight: 150,
        boxSpacing: {
          horizontal: 2,
          vertical: 2
        },
        containerPadding: {
          top: 50,
          right: 30,
          bottom: 50,
          left: 30
        }
      }
    };
  },
  methods: {
    showInFeed: function(item) {
      this.$store.commit("setFeedPostId", item.id);
      this.$router.push({ path: "/feed" });
    },
    checkForLazyLoad: function() {
      let bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight >
        document.documentElement.offsetHeight - 20;

      if (bottomOfWindow) {
        this.$store.dispatch("loadMorePosts", Constants.GALLERY_ITEMS_PER_PAGE);
      }
    },
    setWindowWidth: function() {
      this.windowWidth = window.innerWidth;
      this.galleryOptions.containerPadding = this.getGalleryPadding();
    },
    getGalleryPadding: function() {
      return {
        top: 50,
        right: this.windowWidth < 1000 ? 30 : 200,
        bottom: 50,
        left: this.windowWidth < 1000 ? 30 : 200
      };
    }
  },
  mounted() {
    AOS.init();
    this.$store.dispatch("loadMorePosts", Constants.GALLERY_ITEMS_PER_PAGE);
    this.$store.dispatch("loadMorePosts", Constants.GALLERY_ITEMS_PER_PAGE);
    this.setWindowWidth();

    let debouncedLazyLoadFn = this.pDebounce(this.checkForLazyLoad, 100);
    let debouncedWindownWidthFn = this.pDebounce(this.setWindowWidth, 100);
    window.addEventListener("scroll", debouncedLazyLoadFn); //Debouncing for performance benefit
    window.addEventListener("resize", debouncedWindownWidthFn); //Debouncing for performance benefit
  },
  computed: {
    galleryItems() {
      return this.$store.state.loadedPosts.map(post => {
        return {
          id: post.id,
          url: post.gallery.url,
          width: post.gallery.width,
          height: post.gallery.height,
          format: post.format
        };
      });
    }
  }
};
</script>

<style lang="scss">
.gallery-outer {
  width: 100%;
  height: 100%;
}
.gallery-item-template {
  position: relative;
  cursor: pointer;
  height: 100%;
  width: 100%;
  background-color: $brand-light-90;
}
.gallery-icon {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: $brand-light-80;
  font-size: 20px;
}
.justified-item .gallery-item-template img {
  height: 100%;
  width: 100%;
}
</style>
